import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, DataTable, Header } from "grommet";
import { get } from "lodash";
import React, { useEffect } from "react";
import { getOverallUsage, OrganizationUsageDetail } from "./BillingStore";

import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import SkeletonWrapper from "../components/SkeletonWrapper";

const OverallUsage = () => {
    const [loading, setLoading] = React.useState(true);
    const [usage, setUsage] = React.useState([] as OrganizationUsageDetail[]);

    const columns = [
        { property: "name", header: "Name", primary: true, sortable: true, footer: "Total" },
        { property: "aliases.length", header: "Aliases", primary: true, sortable: true, aggregate: "sum", footer: { aggregate: true } },
        { property: "users.length", header: "Users", primary: true, sortable: true, aggregate: "sum", footer: { aggregate: true } },
        { property: "teams.length", header: "Teams", primary: true, sortable: true, aggregate: "sum", footer: { aggregate: true } },
        { property: "tournaments.length", header: "Tournaments", primary: true, sortable: true, aggregate: "sum", footer: { aggregate: true } },
        { property: "leagues.length", header: "Leagues", primary: true, sortable: true, aggregate: "sum", footer: { aggregate: true } },
        { property: "seasons.length", header: "Seasons", primary: true, sortable: true, aggregate: "sum", footer: { aggregate: true } },
    ] as any[];

    useEffect(() => {
        getOverallUsage().then((res) => {
            setUsage(res.result);
            setLoading(false);
        });
    }, []);

    let exportData = () => {
        let aoa = usage.map((r) => {
            let data = columns.map((c) => get(r, c.property));
            return data;
        });

        aoa = [columns.map((c) => c.header)].concat(aoa);

        var ws = XLSX.utils.aoa_to_sheet(aoa);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Data");

        XLSX.writeFile(wb, "export.xlsx");
    };

    const navigate = useNavigate();

    return (
        <SkeletonWrapper loading={loading}>
            <Box direction="row" justify="end">
                <Button primary label="Download" icon={<FontAwesomeIcon color="white" icon={["fad", "download"]}></FontAwesomeIcon>} onClick={exportData}></Button>
            </Box>
            <DataTable
                data={usage}
                columns={columns}
                onClickRow={({ datum }) => {
                    navigate("/admin/billing/organization/" + datum.organizationID);
                }}
            ></DataTable>
        </SkeletonWrapper>
    );
};

export default OverallUsage;
